import { computed, inject, Injectable } from '@angular/core';
import { ApexGrid, ApexTheme, ApexTooltip } from 'ng-apexcharts';
import { ThemeService } from '../services/theme.service';

/**
 * ApexCharts counterpart of {@link WhEchartsThemeService}.
 *
 * Same gap as the ECharts side: no Apex chart in either app passed a `theme`, so
 * axis labels and tooltips rendered with Apex's light defaults on the dark shell.
 * Bind all three inputs on `<apx-chart>`:
 *
 *     [theme]="apex.theme()" [grid]="apex.grid()" [tooltip]="apex.tooltip()"
 *
 * `chart.background` must stay `'transparent'` (see `defaultApexLineChartOptions`)
 * — Apex's dark mode otherwise paints its own `#293450` behind the plot, which
 * clashes with the slate-800 card around it.
 */
@Injectable({ providedIn: 'root' })
export class WhApexThemeService {
  #theme = inject(ThemeService);

  readonly isDark = computed(() => this.#theme.resolved() === 'dark');

  readonly theme = computed<ApexTheme>(() => ({ mode: this.isDark() ? 'dark' : 'light' }));

  /** gray-100 / slate-700 — matches the ECharts `split` line colour. */
  readonly grid = computed<ApexGrid>(() => ({ borderColor: this.isDark() ? '#334155' : '#F3F4F6' }));

  readonly tooltip = computed<ApexTooltip>(() => ({
    theme: this.isDark() ? 'dark' : 'light',
    x: { format: 'dd/MM/yyyy HH:mm:ss' },
  }));
}
